import { CashPaymentInfoRequest, PostSetPaymentRequest } from 'generated/bffInvoices/models';
import { apiClient, ExtendedAxiosResponse } from 'helpers/apiClient';
import { ChannelType } from 'models/ChannelType';

export const api = {
  getPaymentInfo: (url: string, request: CashPaymentInfoRequest): Promise<ExtendedAxiosResponse> =>
    apiClient.post(
      `${url}/v1/financial-documents/cash-payment-info`,
      {
        cuRefNo: request.cuRefNo,
        caRefNo: request.caRefNo,
        documentType: request.documentType,
        installmentCount: request.installmentCount,
        documents: request.documents,
        onlyPastDueDateInsSched: request.onlyPastDueDateInsSched,
      },
      {
        params: {
          channel: ChannelType.MO2_CARE,
          forceCheck: false,
        },
        headers: {
          'X-O2-System-Consumer': 'MO2-CARE',
        },
      }
    ),
  postSetPayment: (url: string, request: PostSetPaymentRequest): Promise<ExtendedAxiosResponse> => {
    return apiClient.post(
      `${url}/v1/financial-documents/payment-url`,
      {
        forgiveFeeNote: request.forgiveFeeNote,
        payDocuments: request.payDocuments,
      },
      {
        params: {
          channel: ChannelType.MO2_CARE,
          forceCheck: false,
        },
        headers: {
          'X-O2-System-Consumer': 'MO2-CARE',
        },
      }
    );
  },
};
